<ng-template #popManagedTeams>
    <p class="text-neutral-700 f-caption fw-semibold mb-2">Managing Teams</p>
    @if(managedTeams?.length) {
        <div *ngFor="let managedTeam of managedTeams">
          <app-managed-teams-only-link [teamID]="managedTeam.teamID" [text]="managedTeam.teamName">
              <a [routerLink]="[getRoutePrefix(managedTeam.teamID), managedTeam.teamID]" class="fw-medium text-neutral-900">{{managedTeam.teamName}}</a>
          </app-managed-teams-only-link>
        </div>
    } @else {
        <p class="f-caption text-neutral-700">This user has no manager permissions in teams</p>
    }

    <p class="text-neutral-700 f-caption fw-semibold mb-2">Managing Locations</p>
    @if(managedLocations?.length) {
    <div *ngFor="let managedTeam of managedLocations">
      <app-managed-teams-only-link [teamID]="managedTeam.teamID" [text]="managedTeam.teamName">
          <a [routerLink]="[getRoutePrefix(managedTeam.teamID), managedTeam.teamID]" class="fw-medium text-neutral-900">{{managedTeam.teamName}}</a>
      </app-managed-teams-only-link>
    </div>
    } @else {
        <p class="f-caption text-neutral-700">This user has no manager permissions in locations</p>
    }
</ng-template>
@if(isTeamManager) {
    <div class="btn btn-link team-manager-popover" [ngbPopover]="popManagedTeams" container="body">
        {{value.permissionDisplayText}} (+{{value.managedTeam.length}})
    </div>
} @else if (role) {
    <span class="me-1">{{value.permissionDisplayText}}</span>
    <span class="btn btn-link team-manager-popover" [ngbPopover]="role" container="body">
         +1 other role
    </span>
}
 @else {
    <div class="text-center">{{value.permissionDisplayText}}</div>

}
